<script lang="ts">
  import CustomerList from "./index/customer-list.svelte";
  import CustomerProjectsList from "./index/customer-projects-list.svelte";
  import { fade } from "svelte/transition";
  import { type CustomerSummary } from "$src/domain/customers/CustomerSummary";
  import type { AuthContext } from "$src/infrastructure/accounts/AuthContext";
  import { getContext } from "svelte";
  import { ContextTokens } from "../contexts/ContextTokens";
  import { type Customer } from "$src/domain/customers/Customer";
  import MainTemplate from "../main/main-template.svelte";
  import TemplateProvider from "../templates/template-provider.svelte";
  import { Button } from "$lib/components/ui/button";

  let { activeGroupStore }: AuthContext = getContext(ContextTokens.Auth);
  let currentPage: number = 1;

  let selectedCustomer: CustomerSummary | null = null;

  const selectCustomer = (event: CustomEvent<Customer>) => {
    selectedCustomer = event.detail;
  };

  const goBack = () => {
    selectedCustomer = null;
  };
</script>

<MainTemplate isEmbedded={true}>
  <div in:fade class="flex flex-row h-full overflow-hidden">
    {#if $activeGroupStore?.groupStoreId}
      <div
        class="{selectedCustomer
          ? 'hidden md:flex'
          : ''} max-w-md flex w-full mx-auto p-1"
      >
        <CustomerList
          groupStoreId={$activeGroupStore.groupStoreId}
          on:customerClick={selectCustomer}
        />
      </div>
      <div
        class="{selectedCustomer
          ? ''
          : 'hidden md:block'} md:block container mx-auto max-w-full p-1 overflow-hidden"
      >
        <CustomerProjectsList
          groupStoreId={$activeGroupStore.groupStoreId}
          customer={selectedCustomer}
          onBack={goBack}
        />
      </div>
    {/if}
  </div>
</MainTemplate>
